module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAANCAMAAABxTNVSAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAABCUExURUdwTC0tLS4uLi0tLS0tLS0tLSkpKSkpKS4uLisrKy0tLS0tLS0tLS0tLSwsLC4uLi4uLi0tLS0tLS4uLi4uLi4uLlW6V3cAAAAVdFJOUwCxdifPiRgE+g2cUGGfQfHjNtnpvbuw5gUAAABtSURBVBjTZY9JEoAwCASJxoS4b/3/r4pbqZELU00NAyJ39V2UX5Xgfzgo4DIcBrSA+oPDiJZSQfWCyaOT9Q6KB65ocygH7QWjQ2/t4ZzH+uWLtqvfxTcjzQwW0do92TlLkkZd9uQyJ/PkfxrYAI6XBMZZpQGOAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/header/up-arr.png
// module id = PE/I
// module chunks = 0